import Api from "./Api";
import { createQueryString } from "./ApiHelper";

export default {
  GetGlobalOptions(payload) {
    if (payload) {
      const query = createQueryString(payload);
      return Api().get(`/global_options${query}`);
    } else {
      return Api().get(`/global_options`);
    }
  },
  GetActiveList(payload) {
    let query = "";
    let length = Object.keys(payload).length;
    if (length > 0) {
      query = "?";
      Object.keys(payload).map((x, index) => {
        if (x !== "tableName") {
          query +=
            index === length - 1 ? `${x}=${payload[x]}` : `${x}=${payload[x]}&`;
        }
      });
    }
    return Api_2(payload).get(
      `/api/admin/tablelist/${payload.tableName}${query}`,
    );
  },
  TestPrint(payload) {
    return Api().get(`/api/pos/testprint/${payload.cinema_id}/${payload.type}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/MasterService.js